import { featureManager } from './feature-manager';
import { firebaseFeatureProvider, userFeatureProvider } from './providers';

featureManager.registerProvider(userFeatureProvider);
featureManager.registerProvider(firebaseFeatureProvider);

// for now disable feature manager as we need to make sure the backend API works
// featureManager.init();
